"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticChipPropTypes = void 0;

var _stencilReactDesc = require("@amzn/stencil-react-desc");

var staticChipPropTypes = {
  avatar: _stencilReactDesc.PropTypes.shape({
    username: _stencilReactDesc.PropTypes.string.isRequired,
    fullName: _stencilReactDesc.PropTypes.string,
    isUsernameClickable: _stencilReactDesc.PropTypes.bool,
    newTabHiddenText: _stencilReactDesc.PropTypes.string
  }).description('Show avatar as chip content.'),
  dismissButtonAltText: _stencilReactDesc.PropTypes.string.description('Alt text used for the dismiss button in the chip.'),
  dismissButtonRef: _stencilReactDesc.PropTypes.oneOfType([_stencilReactDesc.PropTypes.func, _stencilReactDesc.PropTypes.shape({
    current: _stencilReactDesc.PropTypes.any
  })]).description('Reference to attach to the dismiss button.'),
  onDismiss: _stencilReactDesc.PropTypes.func.description('Makes the chip dismissible. This function will then be called when the user clicks the X button (dismiss button) in the chip. The argument allows to distinguish whether the action was triggered by mouse or keyboard.').format("(triggeredBy: 'keyboard' | 'mouse' ) => void")
};
exports.staticChipPropTypes = staticChipPropTypes;